import React,{useContext} from 'react';
import {motion} from 'framer-motion';
import {AppContext} from '../context/AppContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiUser, FiStar} = FiIcons;

const GuestCard=({guest, index})=> {
  const isOdd = index % 2 !== 0;
  const borderClass = isOdd ? 'border-l-nba-red/50 hover:border-l-nba-red' : 'border-l-nba-blue/50 hover:border-l-nba-blue';
  const roleColorClass = isOdd ? 'text-nba-red' : 'text-nba-blue';

  return (
    <motion.div 
      initial={{opacity: 0, y: 20}}
      whileInView={{opacity: 1, y: 0}}
      viewport={{once: true}}
      className={`bg-nba-card border border-white/5 border-l-4 ${borderClass} transition-all group overflow-hidden shadow-xl flex flex-col sm:flex-row`}
    >
      <div className="w-full sm:w-48 h-64 sm:h-auto shrink-0 bg-nba-dark border-b sm:border-b-0 sm:border-r border-white/5 relative overflow-hidden">
        {guest.image ? (
          <img src={guest.image} alt={guest.name} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-white/10 group-hover:text-white/20 transition-colors">
            <SafeIcon icon={FiUser} className="text-6xl mb-2" />
          </div>
        )}
      </div>
      
      <div className="p-6 md:p-8 flex flex-col flex-1 justify-center">
        <div className={`text-[10px] sm:text-xs font-black uppercase tracking-[0.4em] mb-2 flex items-center gap-2 ${roleColorClass}`}>
          <SafeIcon icon={FiStar} className="shrink-0" /> {guest.role || 'Special Guest'}
        </div>
        
        <h3 className="font-league text-5xl sm:text-6xl text-white uppercase italic tracking-tighter leading-none mb-4 group-hover:drop-shadow-md transition-all">
          {guest.name}
        </h3>
        
        {guest.description && (
          <p className="text-white/60 text-sm sm:text-base leading-relaxed font-body">
            {guest.description}
          </p>
        )}
      </div>
    </motion.div>
  );
};

const Guests=()=> {
  const {guests, textStyles} = useContext(AppContext);

  return (
    <div className="py-12 space-y-10 max-w-6xl mx-auto px-4 min-h-[75vh]">
      <div className="border-b-4 border-white pb-6 space-y-6">
        <h1 className="font-league italic leading-none tracking-tighter uppercase dyn-guestsTitle">
          {textStyles.guestsTitle?.text || 'SPECIAL GUESTS'}
        </h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 pt-4">
        {guests.length > 0 ? (
          guests.map((guest, idx) => (
            <GuestCard key={guest.id} guest={guest} index={idx} />
          ))
        ) : (
          <div className="col-span-full py-20 text-center text-white/20 font-league text-4xl uppercase italic">
            Nessun ospite inserito.
          </div>
        )}
      </div>
    </div>
  );
};

export default Guests;